module.exports = __webpack_public_path__ + "static/media/instruct1.ee87d763.png";